import layout from 'layouts/default'
import { hasPermits } from 'directives'
import timepicker from 'components/timepicker'
import _ from 'lodash'

const directives = {
  hasPermits
}

const components = {
  layout,
  timepicker,
}

const computed = {
  
}

const methods = {
  addAttribute(index = -1) {
    this.editIntegrationAttributes = true;
    let item = {
      key: '',
      value: '',
    }
    
    let length = this.attributes.length; 
    if (index == -1 || index >= length) {
      this.attributes.push(item);
    } else {
      this.attributes.splice(index, 0, item);
    }
    this.onchange();
  },

  removeAttribute(index) {
    this.attributes.splice(index, 1);
    this.onchange();
  },

  onchange() {
    this.$emit('input', this.attributes);
  },

  labelFor(attribute) {
    const definition = _.find(this.definitions, item => item.key === attribute.key);
    return (definition && definition.label) || attribute.label || attribute.key;
  },

  startEdit() {
    this.editIntegrationAttributes = true;
  },
}

export default {
  name: "integration-system-attributes",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    errorPrefix: {
      type: String,
      default: 'integration_system_attributes'
    },
    definitions: {
      type: Array,
      default: () => []
    }
  },
  computed,
  components,
  methods,
  directives,
  data () {
    return {
      locId: this.$route.params.id,
      attributes: _.cloneDeep(this.value) || [],
      loading: false,
      processing: false,
      editIntegrationAttributes: false,
    }
  },
  watch: {
    value (val) {
      if (!_.isEqual(val, this.attributes)) {
        this.attributes = _.cloneDeep(val) || []
      }
    }
  },
  created () {
  },

  mounted() {
  }
}
